import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/global.css';

// Pages
import Home from './pages/Home/Home';
import AInsteinRoutes from './apps/ainstein/routes';
import EunoiaRoutes from './apps/eunoia/routes';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ainstein/*" element={<AInsteinRoutes />} />
        <Route path="/eunoia/*" element={<EunoiaRoutes />} />
      </Routes>
    </Router>
  );
}

export default App;
